module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7LG76"))).then(() => parcelRequire('5kZAa'));